import request from '@/utils/request'

// 查询银河打本剧本激活列表
export function pageScriptActivation(query) {
  return request({
    url: '/played/script/activation/list',
    method: 'get',
    params: query
  })
}

// 解绑
export function unbind(id) {
  return request({
    url: '/played/script/activation/unbind/' + id,
    method: 'put'
  })
}
